import { AuthResponseDto, TwoFactorDto } from "@resume-studio/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { ADMIN_USER_KEY } from "../../constants/query-keys";
import { axios } from "../../libs/axios";
import { queryClient } from "../../libs/query-client";
import { useAuthStore } from "../../stores/auth";

export const adminVerifyOtp = async (data: TwoFactorDto) => {
  const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, TwoFactorDto>(
    "/admin/auth/2fa/verify",
    data,
  );

  return response.data;
};

export const useAdminVerifyOtp = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: verifyOtpFn,
  } = useMutation({
    mutationFn: adminVerifyOtp,
    onSuccess: (data) => {
      setUser(data.user);
      queryClient.setQueryData(ADMIN_USER_KEY, data.user);
    },
  });

  return { verifyOtp: verifyOtpFn, loading, error };
};
